<template>
	<div class="chat-input-container">
		<div class="file-list" v-if="uploadedFiles.length>0">
			<div v-for="(file, index) in uploadedFiles" :key="index" class="file-item">

				<!-- 文件名（溢出省略） -->
				<div class="file-name">{{file.name}}</div>

				<!-- 文件大小 -->
				<div class="file-size">{{formatFileSize(file.size)}}</div>

				<!-- 移除按钮 -->
				<button class="remove-btn" @click="removeFile(index)">×</button>
			</div>
		</div>

		<div class="input-wrapper">
			<div class="input-actions">
				<button class="file-btn" @click="selectFile">
					<svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
						<path fill="currentColor" fill-rule="evenodd"
							d="M9.035 15.956a1.29 1.29 0 0 0 1.821-.004l6.911-6.911a3.15 3.15 0 0 0 0-4.457l-.034-.034a3.15 3.15 0 0 0-4.456 0l-7.235 7.234a5.031 5.031 0 0 0 7.115 7.115l6.577-6.577a1.035 1.035 0 0 1 1.463 1.464l-6.576 6.577A7.1 7.1 0 0 1 4.579 10.32l7.235-7.234a5.22 5.22 0 0 1 7.382 0l.034.034a5.22 5.22 0 0 1 0 7.383l-6.91 6.91a3.36 3.36 0 0 1-4.741.012l-.006-.005-.012-.011a3.346 3.346 0 0 1 0-4.732L12.76 7.48a1.035 1.035 0 0 1 1.464 1.463l-5.198 5.198a1.277 1.277 0 0 0 0 1.805z"
							clip-rule="evenodd"></path>
					</svg>
				</button>


			</div>
			<textarea v-model="message" class="chat-input" :placeholder="placeholder" :disabled="disabled"
				@keydown.enter.prevent="handleEnter" @input="adjustHeight" ref="textarea" rows="1"></textarea>

			<div class="input-actions">
				<button v-if="!disabled" class="send-btn" :disabled="!message.trim()" @click="sendMessage">
					<svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
							d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"></path>
					</svg>
				</button>

				<button v-else class="stop-btn" @click="$emit('stop')">
					<svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
							d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
							d="M9 10a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z"></path>
					</svg>
				</button>
			</div>
		</div>

		<div class="input-tips">
			<span>Shift + Enter 换行，Enter 发送</span>
		</div>


		<!-- 隐藏的文件输入 -->
		<input ref="fileInput" type="file" accept=".pdf,.doc,.docx,.ppt,.pptx,.txt,.epub,.mp3,.wav,.m4a,.flac,.ogg,.aac"
			multiple style="display: none;" @change="handleFileSelect">

	</div>
</template>

<script>
	import {
		apiUrlNew
	} from '../../../config/app.js'
	export default {
		name: 'ChatInput',

		props: {
			disabled: {
				type: Boolean,
				default: false
			}
		},

		data() {
			return {
				message: '',
				uploadedFiles: [],
				userId:null,
			}
		},

		computed: {
			placeholder() {
				return this.disabled ? 'AI正在思考中...' : '输入您的问题...'
			}
		},
		mounted(){
			this.getUserId()
		},
		methods: {
			getUserId(){
				console.log('getUserId')
				let currentUser=sessionStorage.getItem('currentUser')
				try{
					currentUser=JSON.parse(currentUser)
					console.log(currentUser)
					if (currentUser?.user?.userId){
						this.userId=currentUser.user.userId
						console.log(`获取到用户ID:${this.userId}`)
					}
				}catch(e){
					console.error('获取登录信息异常')
				}
				
			},
			handleEnter(event) {
				if (event.shiftKey) {
					// Shift + Enter: 换行
					return
				}
				// Enter: 发送消息
				this.sendMessage()
			},

			sendMessage() {
				if (this.message.trim() && !this.disabled) {
					this.$emit('send', this.message)
					this.message = ''
					this.$nextTick(() => {
						this.adjustHeight()
					})
				}
			},

			adjustHeight() {
				const textarea = this.$refs.textarea
				textarea.style.height = 'auto'
				textarea.style.height = Math.min(textarea.scrollHeight, 200) + 'px'
			},

			showNotification(msg, type) {
				if (type == 'success') {
					this.$message.success(msg)
				} else if (type == 'error') {
					this.$message.error(msg)
				} else if (type == 'warning') {
					this.$message.warning(msg)
				} else {
					this.$message.info(msg)
				}
			},
			selectFile() {
				this.$refs.fileInput.click()
			},
			// 格式化文件大小（B -> KB/MB）
			formatFileSize(size) {
				if (size < 1024) {
					return `${size} B`
				} else if (size < 1024 * 1024) {
					return `${(size / 1024).toFixed(1)} KB`
				} else {
					return `${(size / (1024 * 1024)).toFixed(1)} MB`
				}
			},
			// 移除文件
			removeFile(index) {
				this.uploadedFiles.splice(index, 1)
				this.$message.info('文件已移除')
			},
			getUploadedFiles(){
				return this.uploadedFiles
			},
			async handleFileSelect(event) {
				//下面代码从另外一个系统借鉴过来的,兼容一些方法如showNotification
				const showNotification = this.showNotification
				const generateId = () => {
					return 'id_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9)
				}


				const files = event.target.files
				if (!files || files.length === 0) return

				for (let file of files) {
					// 验证文件类型
					const validTypes = [
						'application/pdf',
						'application/msword',
						'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
						'application/vnd.ms-powerpoint',
						'application/vnd.openxmlformats-officedocument.presentationml.presentation',
						'text/plain',
						'application/epub+zip',
						'audio/mpeg',
						'audio/mp3',
						'audio/wav',
						'audio/x-wav',
						'audio/mp4',
						'audio/x-m4a',
						'audio/flac',
						'audio/ogg',
						'audio/aac'
					]

					const validExtensions = ['.pdf', '.doc', '.docx', '.ppt', '.pptx', '.txt', '.epub', '.mp3', '.wav',
						'.m4a', '.flac', '.ogg', '.aac'
					]
					const hasValidExtension = validExtensions.some(ext => file.name.toLowerCase().endsWith(ext))

					const extensionsArr=file.name.toLowerCase().split('.')
					const extensionName=extensionsArr[extensionsArr.length-1]
					if (!validTypes.includes(file.type) && !hasValidExtension) {
						showNotification(`不支持的文件类型: ${file.name}`, 'error')
						continue
					}

					// 验证文件大小
					const isAudio = file.name.match(/\.(mp3|wav|m4a|flac|ogg|aac)$/i)
					const maxSize = isAudio ? 50 * 1024 * 1024 : 20 * 1024 * 1024

					if (file.size > maxSize) {
						showNotification(`文件大小超过限制: ${file.name}`, 'error')
						continue
					}

					// 检查是否已上传
					if (this.uploadedFiles.some(f => f.name === file.name)) {
						showNotification(`文件已存在: ${file.name}`, 'warning')
						continue
					}

					try {
						// loading.value = true
						showNotification(`正在上传文件: ${file.name}`, 'info')

						// 1. 先上传文件到服务器
						const formData = new FormData()
						formData.append('file', file)
						formData.append('user_id', this.userId ? this.userId : 1)
						formData.append('kb_id', 'autokb')
						formData.append('ka_name', 'autokb')
						formData.append('description', `聊天上传文件: ${file.name}`)
						formData.append('function_desc', `聊天附件`)
						formData.append('domain', `chat`)
						formData.append('type', extensionName)
						const uploadResponse = await fetch(`${apiUrlNew}/files/upload`, {
							method: 'POST',
							body: formData
						})

						if (!uploadResponse.ok) {
							throw new Error('文件上传失败')
						}

						let uploadResult = await uploadResponse.json()
						console.log('uploadResult', uploadResult)
						//下面复制过来的,返回结构存在问题，少了一层，因此模拟结构，后面去掉这段即可
						if (uploadResult.id) {
							uploadResult = {
								code: 200,
								data: uploadResult
							}
						} else {
							uploadResult = {
								code: 500,
								data: uploadResult,
								message: '文件上传失败'
							}
						}

						if (uploadResult.code !== 200) {
							throw new Error(uploadResult.message || '文件上传失败')
						}

						// 2. 添加文件到前端列表
						const fileObject = {
							id: generateId(),
							name: file.name,
							size: file.size,
							type: file.type,
							uploadedAt: new Date().toISOString(),
							file: file,
							isAudio: isAudio,
							path: uploadResult.data.file_path
						}

						this.uploadedFiles.push(fileObject)
						showNotification(`文件上传成功: ${file.name}`, 'success')

						return

						// 3. 调用文件解析接口，将文件解析成向量并存储到向量数据库
						const parseResponse = await fetch(`${apiUrlNew}/data/add-by-file`, {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json'
							},
							body: JSON.stringify({
								db_id: 'default', // 使用默认知识库，或者从配置中获取
								files: [uploadResult.data.file_path],
								user_id: 1
							})
						})

						if (!parseResponse.ok) {
							throw new Error('文件解析失败')
						}

						const parseResult = await parseResponse.json()

						if (parseResult.status === 'success' || parseResult.status === 'partial_success') {
							showNotification(`文件解析完成，已添加到知识库: ${file.name}`, 'success')

							// 更新文件状态
							// const fileIndex = this.uploadedFiles.findIndex(f => f.id === fileObject.id)
							// if (fileIndex > -1) {
							// 	this.uploadedFiles[fileIndex].parsed = true
							// 	this.uploadedFiles[fileIndex].parseStatus = 'success'
							// }
							this.uploadedFiles.push(fileObject)
						} else {
							showNotification(`文件上传成功，但解析失败：${file.name}`, 'error')

							// 更新文件状态
							const fileIndex = this.uploadedFiles.findIndex(f => f.id === fileObject.id)
							if (fileIndex > -1) {
								this.uploadedFiles[fileIndex].parsed = false
								this.uploadedFiles[fileIndex].parseStatus = 'failed'
							}
						}

					} catch (error) {
						console.error('文件处理失败:', error)
						showNotification(`文件处理失败：${file.name} - ${error.message}`, 'error')
					} finally {
						// loading.value = false
					}

					// const files = event.target.files
					// if (files.length > 0) {
					//   this.$emit('fileSelect', files)
					// }
					// this.$refs.fileInput.value = '' // 清空文件输入，以便可以重新选择相同的文件
				}
			}
		},
	}
</script>

<style scoped>
	.chat-input-container {
		padding: 20px;
		background: white;
		border-top: 1px solid var(--border-light);
		position: relative;
	}

	.input-wrapper {
		display: flex;
		align-items: flex-end;
		gap: 12px;
		background: var(--bg-light);
		border-radius: 24px;
		padding: 8px 16px;
		transition: all 0.3s ease;
		max-width: 100%;
		box-sizing: border-box;
	}

	.input-wrapper:focus-within {
		box-shadow: 0 0 0 2px var(--primary);
		background: #f8f9fa;
	}

	.chat-input {
		flex: 1;
		background: none;
		border: none;
		outline: none;
		font-size: 16px;
		line-height: 1.5;
		resize: none;
		min-height: 24px;
		max-height: 200px;
		color: var(--text-dark);
		font-family: inherit;
		width: 100%;
		box-sizing: border-box;
		position: relative;
		z-index: 2;
		pointer-events: auto;
		padding: 8px 0;
		margin: 0;
		vertical-align: top;
	}

	.chat-input::placeholder {
		color: var(--text-light);
	}

	.input-actions {
		display: flex;
		align-items: center;
		gap: 8px;
		flex-shrink: 0;
	}

	.send-btn,
	.file-btn,
	.stop-btn {
		width: 36px;
		height: 36px;
		border-radius: 50%;
		border: none;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: all 0.3s ease;
		flex-shrink: 0;
		touch-action: manipulation;
		position: relative;
		z-index: 1;
	}

	.send-btn {
		background: var(--primary);
		color: white;
	}

	.send-btn:hover:not(:disabled) {
		background: var(--primary-dark);
		transform: scale(1.05);
	}

	.send-btn:active:not(:disabled) {
		transform: scale(0.95);
	}

	.send-btn:disabled {
		background: var(--text-light);
		cursor: not-allowed;
		opacity: 0.5;
	}

	.file-btn {
		color: #333;
	}

	.file-btn:hover:not(:disabled) {
		transform: scale(1.05);
	}

	.file-btn:active:not(:disabled) {
		transform: scale(0.95);
	}

	.file-btn:disabled {
		cursor: not-allowed;
		opacity: 0.5;
	}
	.stop-btn {
		background: #ff3b30;
		color: white;
	}

	.stop-btn:hover {
		background: #d70015;
		transform: scale(1.05);
	}

	.stop-btn:active {
		transform: scale(0.95);
	}

	.input-tips {
		margin-top: 8px;
		text-align: center;
		font-size: 12px;
		color: var(--text-light);
		user-select: none;
	}

	/* 平板设备 (768px - 1024px) */
	@media (max-width: 1024px) {
		.chat-input-container {
			padding: 16px 20px;
		}

		.input-wrapper {
			gap: 10px;
			padding: 6px 14px;
		}

		.chat-input {
			font-size: 15px;
			padding: 6px 0;
		}
	}

	/* 手机设备 (小于768px) */
	@media (max-width: 768px) {
		.chat-input-container {
			padding: 12px 16px;
			border-top: 1px solid var(--border-light);
		}

		.input-wrapper {
			gap: 8px;
			padding: 6px 12px;
			border-radius: 20px;
		}

		.chat-input {
			font-size: 16px;/* 保持16px防止iOS缩放 */
			min-height: 20px;
			max-height: 150px;
			padding: 6px 0;
		}

		.send-btn,
		.file-btn,
		.stop-btn {
			width: 32px;
			height: 32px;
			min-width: 32px;
			min-height: 32px;
		}

		.send-btn svg,
		.file-btn svg,
		.stop-btn svg {
			width: 18px;
			height: 18px;
		}


		.input-tips {
			display: none;
		}
	}

	/* 小屏手机 (小于480px) */
	@media (max-width: 480px) {
		.chat-input-container {
			padding: 10px 12px;
		}

		.input-wrapper {
			gap: 6px;
			padding: 4px 10px;
			border-radius: 18px;
		}

		.chat-input {
			font-size: 16px;
			line-height: 1.4;
			padding: 4px 0;
		}

		.send-btn,
		.file-btn,
		.stop-btn {
			width: 30px;
			height: 30px;
			min-width: 30px;
			min-height: 30px;
		}

		.send-btn svg,
		.file-btn svg,
		.stop-btn svg {
			width: 16px;
			height: 16px;
		}
	}

	/* 超宽屏设备 (大于1200px) */
	@media (min-width: 1200px) {
		.chat-input-container {
			padding: 24px 32px;
		}

		.input-wrapper {
			/* max-width: 800px; */
			margin: 0 auto;
		}
	}

	/* 横屏手机适配 */
	@media (max-height: 500px) and (orientation: landscape) {
		.chat-input-container {
			padding: 8px 12px;
		}

		.input-wrapper {
			padding: 4px 10px;
		}

		.chat-input {
			max-height: 80px;
			padding: 4px 0;
		}

		.input-tips {
			display: none;
		}
	}

	/* 高分辨率设备优化 */
	@media (-webkit-min-device-pixel-ratio: 2),(min-resolution: 192dpi) {
		.send-btn,
		.file-btn,
		.stop-btn {
			border: 0.5px solid rgba(255, 255, 255, 0.1);
		}
	}

	/* 深色模式适配 */
	@media (prefers-color-scheme: dark) {
		.input-wrapper {
			background: #2a2a2a;
			border: 1px solid #404040;
		}

		.input-wrapper:focus-within {
			background: #333;
			box-shadow: 0 0 0 2px var(--primary);
		}

		.chat-input {
			color: #fff;
		}

		.chat-input::placeholder {
			color: #888;
		}
	}

	/* 动画优化 */
	@media (prefers-reduced-motion: reduce) {
		.send-btn,
		.file-btn,
		.stop-btn,
		.input-wrapper {
			transition: none;
		}

		.send-btn:hover:not(:disabled),
		.file-btn:hover:not(:disabled),
		.stop-btn:hover {
			transform: none;
		}
	}

	/* 键盘弹出时的适配 (iOS Safari) */
	@supports (-webkit-touch-callout: none) {
		@media (max-width: 768px) {
			.chat-input-container {
				padding-bottom: max(12px, env(safe-area-inset-bottom));
			}
		}
	}
	
	/* 文件列表样式 */
	.file-list {
		margin-bottom: 10px;
		padding: 7px;
		min-height: 40px;
		/* 确保即使没有文件也有占位空间 */
	}

	.file-item {
		display: inline-flex;
		align-items: center;
		gap: 8px;
		padding: 6px 10px;
		margin: 0 8px 8px 0;
		border: 1px solid #e5e6eb;
		border-radius: 6px;
		background: #f5f7fa;
		width: 280px;
		/* 固定宽度 */
		height: 40px;
		/* 固定高度 */
		box-sizing: border-box;
		white-space: nowrap;
		/* 防止内部元素换行 */
	}

	.file-name {
		flex-grow: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		/* 文件名溢出省略 */
		margin: 0 4px;
		font-size: 12px;
	}

	.file-size {
		font-size: 11px;
		color: #888;
		flex-shrink: 0;
		/* 大小不收缩 */
	}
	.remove-btn {
		font-size: 16px;
		width: 30px;
		height: 30px;
	}
</style>